import axios from "axios";
import { getToken, clearAuth } from "./secureStorage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  // getToken() auto-expires stale JWTs (exp claim < now).
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      clearAuth();
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    // Normalise FastAPI/Pydantic v2 validation errors — the raw `detail`
    // is `[{type, loc, msg, input, url}, ...]`. React chokes if any caller
    // renders it directly. Collapse to a single readable string once so
    // every downstream `.detail` consumer keeps working unchanged.
    try {
      const d = err?.response?.data?.detail;
      if (Array.isArray(d)) {
        err.response.data.detail = d
          .map((e) => {
            if (!e || typeof e !== "object") return String(e);
            const path = Array.isArray(e.loc) ? e.loc.filter((p) => p !== "body").join(".") : "";
            return path ? `${path}: ${e.msg || "invalid"}` : (e.msg || "invalid");
          })
          .join(" · ");
      } else if (d && typeof d === "object") {
        err.response.data.detail = d.msg || JSON.stringify(d);
      }
    } catch { /* leave detail as-is */ }
    return Promise.reject(err);
  }
);

export default api;
